module.exports = __webpack_public_path__ + "img/step10.14.525786b7.png";